import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpRequestService } from '../../shared/services/http-request.service';
import { apiURLs } from '../../shared/globalcontants';
import * as appApiResources from '../../shared/globalcontants';
import { map, catchError } from 'rxjs/operators';
import { of as observableOf, Observable, throwError } from 'rxjs';
import { EatecTokenRefreshService } from './eatec-token-refresh.service';
import { applyEatecTokenPayloadToStorage, clearEatecTokenAuxStorage } from './eatec-token-session.helper';
import { UserToken } from '../../shared/models/Account/UserTokenEntity';
import { ToastrService } from 'ngx-toastr';
import { UserDetailLandingEntity } from 'src/app/shared/models/Account/UserInstancesEntity';
import moment from 'moment-timezone';


@Injectable()
export class AuthenticationService {
  token = {
    refresh_token: 'refreshtokencode',
    exp: moment().add(1, 'day').toDate(),
    access_token: {
      username: 'user',
      roles: ['Admin', 'RegisteredUser', 'Super User']
    }
  };


  constructor(
    private router: Router,
    private httpService: HttpRequestService,
    private toastrService: ToastrService,
    private eatecTokenRefreshService: EatecTokenRefreshService
    ) { }

  login(username, password): Observable<UserToken> {
    const data = 'username=' + username + '&password=' + password + '&grant_type=password';
    return this.httpService.postHttpRequestwithAuth(apiURLs.GetToken, data)
      .pipe(
        map(user => {
          if (user && user.access_token) {
            applyEatecTokenPayloadToStorage(user);
          }
          return <UserToken>user;
        }),
        catchError((error: any) => throwError(() => error))
      );
  }

  logout() {
    EatecTokenRefreshService.stopRefreshTimer();
    clearEatecTokenAuxStorage();
    localStorage.removeItem(appApiResources.userSessionName);
    this.router.navigate(['/login']);
  }

  /**
  * @version 13.3 UI;
  * @method updateMobileLogoutDetails
  * @input None
  *
  */
  updateMobileLicenseLogout() {
    try {
      const UserId = sessionStorage.getItem(appApiResources.loggedInUserId)
      const deviceId = localStorage.getItem(appApiResources.DeviceId);
      let deviceDetail = JSON.parse(localStorage.getItem("activeDeviceDetail"))
      this.UpdateMobileLogoutDetails(deviceDetail).subscribe(result => {
        console.log(result,'MobileLicenseLogout response')
      }, err => {
        console.log(err);
      }
      );
    } catch (error) {
      console.error(error);
    }
  }

  UpdateMobileLogoutDetails(deviceDetail: any): Observable<any> {
    let endPoint= apiURLs.UserManagementApi.UpdateMobileLogoutDetails+'/'+deviceDetail?.UserId+'/'+deviceDetail?.DeviceId+'/'+deviceDetail?.SessionId
    return this.httpService.postHttpRequest(endPoint,{});
  }

  UnExceptionalLogout(request: any, next: any): void {
    this.toastrService.error('everything is broken', 'Major Error', {
      timeOut: 1000,
    });
    EatecTokenRefreshService.stopRefreshTimer();
    clearEatecTokenAuxStorage();
    localStorage.removeItem(appApiResources.userSessionName);
    this.router.navigate(['/login']);
  }

  refreshToken(): Observable<UserToken> {
    return this.eatecTokenRefreshService.performEatecRefresh().pipe(
      map((user: any) => {
        if (user && (user.access_token || user.AccessToken)) {
          applyEatecTokenPayloadToStorage(user);
        }
        return user as UserToken;
      })
    );
  }

  getAuthToken(): string {
    const currentUser = JSON.parse(localStorage.getItem(appApiResources.userSessionName));
    if (currentUser != null) {
      return currentUser.access_token;
    }
    return '';
  }

  getInstanceFromLocal(): string {
    const instanceName = localStorage.getItem(appApiResources.instanceName);
    if (instanceName != null) {
      return instanceName;
    }
    return '';
  }
  getDeviceIdFromLocal(): string {
    const DeviceId = localStorage.getItem('DeviceId');
    if (DeviceId != null) {
      return DeviceId;
    }
    return '';
  }

  getDeviceNameFromLocal(): string {
    const DeviceName = localStorage.getItem('DeviceName');
    if (DeviceName != null) {
      return DeviceName;
    }
    return '';
  }


  getAcceptLanguageFromLocal(): string {
    const currentUserLanguage = sessionStorage.getItem(appApiResources.loggedInUserlanguage);
    if (currentUserLanguage != null) {
      return currentUserLanguage;
    }
    return 'en';
  }

  getUserLanguage(): string {
    const currentUserLanguage = localStorage.getItem(appApiResources.loggedInUserlanguage);
    if (currentUserLanguage != null) {
      return currentUserLanguage;
    }
    return 'en';
  }

  getAccessToken() {
    return JSON.parse(localStorage.getItem(appApiResources.userSessionName))['access_token'];
  }

  isAuthenticated() {
    const token = localStorage.getItem(appApiResources.userSessionName);
    if (token) {
      return true;
    } else {
      return false;
    }
  }

  // refreshToken() {
  //  this.token.exp = moment((moment().toDate().getDate() +1)).toDate();
  //  this.setToken(this.token);
  // }

  clearLocalStorage() {
    EatecTokenRefreshService.stopRefreshTimer();
    clearEatecTokenAuxStorage();
    // localStorage.clear();
    localStorage.removeItem('currentUser');
    localStorage.removeItem('uiMenus');
    localStorage.removeItem('instanceName');
    localStorage.removeItem('userPrivileges');
    localStorage.removeItem('ReceivingSupplierList');
    localStorage.removeItem('ReceivingLocation');
    if (localStorage.hasOwnProperty('transactionId')) {
      localStorage.removeItem('transactionId');
    } if (localStorage.hasOwnProperty('IsOfflinePage')) {
      localStorage.removeItem('IsOfflinePage');
    }
    sessionStorage.clear();
  }
  removeToken() {
    EatecTokenRefreshService.stopRefreshTimer();
    clearEatecTokenAuxStorage();
    localStorage.removeItem(appApiResources.userSessionName);
  }

}
